// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/designation.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { designationsApi } from "../../api/designations";
import type { Designation } from "../../api/types";
// override-block:imports BEGIN
import type { DesignationStatus, DesignationType } from "../../api/types";
// CHG-1294 — per-page RBAC gate wiring (consumes GATE_CATALOG).
import { GATE_CATALOG } from "../../auth/gateCatalog";
import { toGate } from "../../auth/toGateProp";
// override-block:imports END

// override-block:helpers BEGIN
const STATUS_LABEL: Record<DesignationStatus, string> = {
  active: "Active",
  paused: "Paused",
  completed: "Completed",
  archived: "Archived",
};
const TYPE_LABEL: Record<DesignationType, string> = {
  fund: "Fund",
  project: "Project",
  program: "Program",
  cause: "Cause",
  milestone: "Milestone",
};
// override-block:helpers END

export const designationListConfig: ListPageConfig<Designation> = {
  title: "Designations",
  subtitle: "Funds, projects, and programs — every donor-facing giving category.",
  queryKey: ["designations", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search }) =>
    designationsApi.listDesignations({ page, pageSize, sortField, sortDirection, search }),
  defaultSort: { field: "display_order", direction: "asc" },
  pageSize: 50,
  rowHref: "/designations/{id}",
  search: { enabled: true, placeholder: "Search designations by name or type…" },
  emptyState: {
    title: "No designations yet",
    subtitle: "Create your first designation to start accepting categorized gifts.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    { id: "edit", label: "Edit", variant: "secondary", permissionGate: toGate(GATE_CATALOG.designation_list["edit"], "disable") },
    { id: "reorder", label: "Reorder", variant: "ghost", permissionGate: toGate(GATE_CATALOG.designation_list["reorder"], "disable") },
    // override-block:header-actions END
  ],
  columns: [
    { field: "name", label: "Name", type: "text", sortable: true },
    // override-block:column-designation-type BEGIN
    {
      field: "designation_type",
      label: "Type",
      type: "custom",
      sortable: true,
      render: (row) => TYPE_LABEL[row.designation_type] ?? row.designation_type,
    },
    // override-block:column-designation-type END
    // override-block:column-allow-recurring BEGIN
    {
      field: "allow_recurring",
      label: "Recurring",
      type: "custom",
      render: (row) => (row.allow_recurring ? "Yes" : "No"),
    },
    // override-block:column-allow-recurring END
    { field: "raised_minor_units", label: "Raised", type: "currency", currencyField: "goal_currency", sortable: true },
    // override-block:column-donation-count BEGIN
    {
      field: "donation_count",
      label: "Donations",
      type: "custom",
      sortable: true,
      // donation_count is `field_source: derived` per CHG-1237 — backend
      // may not surface yet; render "—" when absent.
      render: (row) => (row.donation_count != null ? String(row.donation_count) : "—"),
    },
    // override-block:column-donation-count END
    // override-block:column-status BEGIN
    {
      field: "status",
      label: "Status",
      type: "custom",
      render: (row) => STATUS_LABEL[row.status] ?? row.status,
    },
    // override-block:column-status END
  ],
};
